import {CHANGE_LANGUAGE} from '../constants';

let loy3User = JSON.parse(localStorage.getItem('_loy3User'));
let brand = JSON.parse(localStorage.getItem('_brand'));
const initialState = {
  lang: loy3User && brand && loy3User.locale ? loy3User.locale : (brand ? brand.locale : 'en')

};
export const language = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        lang: action.lang && action.lang
      };
    default:
      return state
  }
};
